<template>
  <div
    role="button"
    data-name="ui-button-wrapper"
    @click="onClick"
    v-touch="onClick"
    :class="$style.wrapper"
  >
    <span :class="$style.text">{{ buttonText }}</span>
  </div>
</template>

<script>
export default {
  name: "ui-button",
  props: {
    buttonText: String,
    buttonAction: Function,
    top: null,
    left: null
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClick: function() {
      this.$props.buttonAction();
    }
  }
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  // margin-top: 20px;
  // margin-bottom: 20px;

  border-radius: 45px;

  // color: white;
  // font-weight: bold;

  background-color: $jaffa;

  cursor: pointer;

  height: 45px;
  color: white;
  font-weight: bold;
  width: auto;
  padding-left: 40px;
  padding-right: 40px;

  &:before {
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 100%;
    margin: -15px 0 0 1px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: darken($jaffa, 15%);
    transform-origin: 100% 50%;
    transition: transform 0.3s, opacity 0.3s;
    content: "";
  }

  &:hover,
  &:focus {
    &:before {
      transform: scale3d(12, 12, 1);
    }
  }
}

.text {
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/UiButton.vue